import { useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

export default function Boissons() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchData = useCallback(async () => {
    try {
      setLoading(true);
      const { data } = await api.get("/boissons");
      setItems(data);
    } catch {
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { fetchData(); }, [fetchData]);

  const byCategory = items.reduce((acc, b) => {
    (acc[b.categorie] = acc[b.categorie] || []).push(b);
    return acc;
  }, {});
  const categories = Object.keys(byCategory);

  return (
    <div data-testid="boissons-page" className="bg-[#FDFBF7]">
      <section className="relative h-[44vh] min-h-[300px] overflow-hidden flex items-end">
        <div className="absolute inset-0 bg-cover bg-center kenburns" style={{ backgroundImage: "url('/images/drinks.jpeg')" }} aria-hidden />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0A0A0A] via-[#0A0A0A]/70 to-[#0A0A0A]/30" aria-hidden />
        <div className="relative z-10 max-w-6xl mx-auto w-full px-6 md:px-10 pb-14 text-white">
          <h1 className="font-serif text-5xl md:text-6xl mb-3">Les boissons</h1>
          <p className="text-white/80 max-w-xl">Une carte de vins, bières et cocktails sélectionnée avec soin pour accompagner vos repas.</p>
        </div>
      </section>

      <div className="max-w-5xl mx-auto px-6 md:px-10 py-20">
        {loading && <p className="text-center text-[#1A1A1A]/60">Chargement…</p>}
        {!loading && items.length === 0 && <p className="text-center text-[#1A1A1A]/60">Aucune boisson publiée pour le moment.</p>}
        <div className="space-y-14">
          {categories.map((cat) => (
            <section key={cat} data-testid={`boissons-cat-${cat}`}>
              <div className="flex items-center gap-6 mb-8">
                <h2 className="font-serif text-3xl md:text-4xl text-[#1A1A1A]">{cat}</h2>
                <span className="flex-1 h-px bg-[#E5E0D8]" />
              </div>
              <ul className="space-y-3">
                {byCategory[cat].map((b) => (
                  <li key={b.id} className="flex items-baseline gap-4 py-2 border-b border-dashed border-[#E5E0D8]">
                    <span className="font-serif text-xl text-[#1A1A1A]">{b.nom}</span>
                    {b.volume && <span className="text-xs uppercase tracking-[0.2em] text-[#1A1A1A]/50">{b.volume}</span>}
                    {b.description && <span className="text-sm text-[#1A1A1A]/60 italic hidden sm:inline">– {b.description}</span>}
                    <span className="flex-1 border-b border-dotted border-[#E5E0D8]" aria-hidden />
                    {b.prix != null && <span className="price-tag text-[#A61C24]">{b.prix.toFixed(2)} €</span>}
                  </li>
                ))}
              </ul>
            </section>
          ))}
        </div>
      </div>
    </div>
  );
}
